
import { Component, Vue } from 'vue-property-decorator'
import eventBus from '@/plugins/eventBus'
import LoginModal from '@/modules/user/LoginModal.vue'
import RegisterModal from '@/modules/user/RegisterModal.vue'
import { getParameter } from '@/plugins/globals'
import { envConfiguration } from '@/plugins/globalStaticDatas'
import { UserModel } from '@/store/models/UserModel'
@Component({
  components: { RegisterModal, LoginModal },
})
export default class UserDropdown extends Vue {
  showDropdown: boolean = false
  userName: string = ''
  isLogged: boolean = false
  user: any = null
  callbacks: Array<Function> = []
  sectorId: any
  envConfigurations: any = envConfiguration
  showDropdownMenu() {
    this.showDropdown = !this.showDropdown
  }

  mounted() {
    this.sectorId = getParameter('sector_id')
    eventBus.$on('user:logged', this.userLogged)
    eventBus.$on('user:start-login', this.loginLogoutAction)
  }

  loginLogoutAction(callback: any) {
    if (callback) {
      this.callbacks.push(callback)
    }
    if (this.isLogged) {
      localStorage.removeItem('user_data')
      localStorage.removeItem('token')
      localStorage.removeItem('unAuthCart')
      window.location.href = `/index.html`
      return
    }
    eventBus.$emit('login_modal:open')
  }

  userLogged(user: any) {
    UserModel.getInstance().isLogged ? (this.isLogged = true) : (this.isLogged = false)
    this.user = user

    this.userName = this.$t('welcome') + this.user.getFullName()
    if (this.callbacks && this.callbacks.length > 0) {
      this.callbacks.forEach((callback) => {
        if (typeof callback === 'function') {
          callback()
        }
      })
    }
  }
}
